const it_IT = {
    translation: {
        "SuccessChangesSaved": "Le tue modifiche sono state salvate",
        "ErrorValuesNotValid": "Alcuni valori non sono validi",
        "LabelSettings": "Impostazioni",
        "LabelConfigureApplication": "Configura la tua applicazione",
        "ButtonTutorial": "TUTORIAL",
        "ButtonPublish": "PUBBLICA",
        "ButtonLiveView": "LIVE VIEW",
        "ButtonSaveChanges": "SALVA MODIFICHE",
        "ButtonAddMenuItem": "AGGIUNGI VOCE MENU",
        "ButtonReset": "RESET",
        "ButtonResetSettings": "RESET IMPOSTAZIONI",
        "ButtonOk": "OK",
        "ButtonRemove": "RIMUOVI",
        "ButtonResetCertificates": "REIMPOSTA VALORI CERTIFICATI",
        "LabelMain": "Impostazioni",
        "LabelInfo": "Generale",
        "LabelAssets": "Assets",
        "LabelIos": "Android # iOS",
        "LabelAndroid": "Android",
        "LabelServices": "Servizi",
        "LabelMenu": "Menu",

        "LabelWelcome": "Benvenuto",
        "LabelWelcome0": "Complimenti, la tua app è pronta!! Vuoi provarla?",
        "LabelWelcome1": "1) Installa sul tuo device l'app di test MyLiveViewer, disponibile sugli Store",
        "LabelWelcome2": "2) Premi il bottone LIVE VIEW nella parte superiore di questa pagina: apparirà un QR Code",
        "LabelWelcome3": "3) Lancia l'app MyLiveViewer sul tuo device e scansiona il QR Code appena generato",
        "LabelWelcome4": "Ora usa la tua app in anteprima per vedere come apparirà quando sarà pubblicata sugli Store",
        "LabelWelcome5": "Puoi trovare un tutorial completo qui:",

        "LabelHints": "Aiuto",

        "LabelSettings": "Reset",
        "LabelSplashScreen": "Splash screen .png (dim. suggerita 1152px X 2046px) *",
        "LabelAppIcon": "Icona App .png (dim. suggerita 1024px X 1024px)*",
        "LabelMenuHeaderBackground": "Sfondo header menù  .png (dim. suggerite 300px X 200px)",
        "LabelUploadHelp": "Trascina i file qui o fai clic qui per cercare nei tuoi file",
        "LabelUploadFile": "CARICA FILE",
        "LabelRemoveFile": "RIMUOVI",
        "LabelRemoveAllFiles": "RIMUOVI TUTTI",
        "LabeliOSBuildEnabled": "Abilita build per iOS",

        "LabeliOSBuildHelpUrl": "documents/iOS-Hints-it_IT.html",

        "LabeliOSP12CertificateFile": "Carica certificato .p12 *",
        "LabeliOSP8CertificateFile": "Carica certificato .p8 *",
        "LabeliOSCertificatePassword": "Password Certificato  *",
        "HelperiOSCertificatePassword": "La password utilizzata per proteggere il certificato",
        "LabeliOSMobileProvisionFile": "Carica file .mobileprovision *",
        "LabelAppTitle": "Titolo App *",
        "HelperAppTitle": "Questo titolo viene mostrato nella barra di navigazione dell'app",
        "LabelMenuTitle": "Titolo Menu",
        "HelperMenuTitle": "Questo titolo viene mostrato nell'header del menù a scomparsa",
        "LabelBundleId": "Bundle Id *",
        "HelperBundleId": "Identifica univocamente una applicazione negli app store, usare la notazione 'reverse domain name' tipo 'com.yourdomain.appName'",
        "LabelVersionNumber": "Numero Versione *",
        "HelperVersionNumber": "Identifica la versione dell'app negli app stores, usare la notazione standard tipo '1.0' ",
        "LabelShareAppIos": "Testo condivisione per iOS",
        "HelperShareAppIos": "Testo utilizzato come corpo del messaggio inviato durante l'utilizzo della funzionalità di share screen dell'app",
        "LabelShareAppAndroid": "Testo condivisione per Android",
        "HelperShareAppAndroid": "Testo utilizzato come corpo del messaggio inviato durante l'utilizzo della funzionalità di share screen dell'app",
        "LabelUseNativeAppSideMenu": "Utilizza menù nativo dell'app",
        "HelperUseNativeAppSideMenu": "Abilita o disabilita il menù di navigazione nativo dell'app",
        "LabelAppPrimaryColor": "Colore Principale App",
        "LabelAppSecondaryColor": "Colore Secondario App",
        "LabelAppTitleColor": "Colore Titolo App",
        "LabelMenuBackgroundColor": "Colore Sfondo Menù",
        "LabelColorHeaderMenu": "Colore Testo Titolo Menù",
        "LabelMenuTitleBackgroundColor": "Colore Sfondo Titolo Menù",
        "LabelMenuItemsTextColor": "Colore Testo Voci Menù",
        "LabelOneSignalAppId": "OneSignal App Id",
        "HelperOneSignalAppId": "Aggiungi il tuo OneSignal App ID per abilitare le notifiche push",
        "LabelSendGripApiKey": "SendGrip Api Key",
        "HelperSendGripApiKey": "Aggiungi la tua SendGrid API Key per abilitare i template delle mail",
        "LabelBackgroundColor": "Colore Sfondo",
        "LabelTitle": "Titolo",
        "LabelTextColor": "Colore Testo",
        "LabelFontSize": "Dimensione Font",
        "LabelFontStyle": "Stile Font",
        "LabelTargetPlatform": "Attivo su dispositivi",
        "LabelVisible": "Visibile",
        "LabelDeleting": "Elimina",
        "LabelDeleteConfirmQuestion": "Sicuro di voler eliminare questa voce di menù?",
        "ButtonCancel": "ANNULLA",
        "ButtonDelete": "ELIMINA",
        "ButtonClose": "CHIUDI",
        "ButtonBack": "INDIETRO",
        "ButtonNext": "AVANTI",
        "ButtonGenerate": "GENERA",
        "LabelAndroidBuildEnabled": "Abilita build per Android",

        "LabelAndroidBuildHelpUrl": "documents/Android-Hints-it_IT.html",

        "LabelAndroidKeyStoreFile": "Carica certificato .keystore *",
        "LabelAndroidKeyStoreAlias": "Keystore Alias *",
        "HelperAndroidKeyStoreAlias": "Alias contenuto nel certificato",
        "LabelAndroidKeyStorePassword": "Password Certificato *",
        "HelperAndroidKeyStorePassword": "La password utilizzata per proteggere il certificato",
        "LabelLinkType": "Tipo Link",
        "LabelUrl": "URL",
        "LabelLink": "Link",
        "LabelPhoneNumber": "Numero di Telefono",
        "LabelThickness": "Spessore",
        "LabelQrUrl": "Invia contenuto codice QR a questo URL",
        "LabelEmail": "Email",
        "LabelTemplateId": "Template Id",
        "LabelIconPickerText": "Scegli un'icona",
        "LabelBuilds": "Builds",
        "LabelDownloadYourBuilds": "SCARICA LE TUE BUILD",
        "LabelBuildName": "NOME",
        "LabelBuildDeviceType": "TIPO DEVICE",
        "LabelBuildStatus": "STATO",
        "LabelBuildDate": "CREATA IL",
        "LabelBuildActions": "AZIONI",
        "LabelBuildDownload": "Download",
        "LabelBuildRedo": "Ripeti compilazione",
        "LabelBuildCancel": "Annulla compilazione",
        "LabelBuildDelete": "Rimuovi compilazione",
        "LabelBuildCompleted": "Completa",
        "LabelBuildNotStarted": "Non Iniziata",
        "LabelBuildInProgress": "In Corso",
        "LabelBuildCancelling": "Annullamento",
        "LabelBuildCanceled": "Annullata",
        "LabelBuildUnknown": "Sconosciuto",
        "LabelBuildFailed": "Fallita",
        "LabelBuildError": "Errore",
        "LabelNoMenuItems": "Nessuna voce di menù definita",
        "LabelJsonUrl": "URL del JSON",
        "LabelMenuItemsBackgroundColor": "Colore Sfondo Voci di Menù",
        "MessageWrongFileSize5": "Immagine non valida, la dimensione massima è di 5mb",
        "MessageWrongFileSize1": "Immagine non valida, la dimensione massima è di 1mb",
        "MessageWrongImageFormat": "Formato immagine non valido, solo .PNG è supportato",
        "MessageiOSInvalidP12File": "Formato file non valido, solo .p12 è supportato",
        "MessageiOSInvalidP8File": "Formato file non valido, solo .p8 è supportato",
        "MessageiOSInvalidPPFile": "Formato file non valido, solo .mobileprovision è supportato",
        "MessageAndroidInvalidKSFile": "Formato file non valido, solo .keystore è supportato",
        "MessageFileUploadOk": "Il tuo file è stato caricato correttamente",
        "SuccessLiveConfigUpdate": "Configurazione live view aggiornata",
        "ErrorLiveConfigUpdate": "Impossibile aggiornare la configurazione live view",
        "SuccessAppConfigUpdate": "Configurazione dell'App pubblicata",
        "ErrorAppConfigUpdate": "Impossibile pubblicare la configurazione ",
        "LabelUserLivewViewer": "Leggi il codice QR usando l'app MyLiveViewer",
        "LabelLivewViewerQrError": "Ci dispiace non siamo riusciti a generare il codice QR, prova più tardi :(",
        "UrlGooglePlayBadge": "https://play.google.com/intl/it_it/badges/static/images/badges/it_badge_web_generic.png",
        "UrlAppStoreBadge": "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/it-it?size=250x83&amp;releaseDate=1605830400&h=cf9c84bebcfeb0d6ebe208e22e464a23",
        "LabelChangesAreMade": "La tua configurazione ha delle modifiche non salvate — salva le modifiche per aggiornarle nel live view o per pubblicarle",
        "ButtonCreateBuild": "CREA BUILD",
        "ButtonBuyLicense": "ACQUISTA",
        "LabelLicenseNotFound": "La tua licenza è scaduta o non è valida — è necessario acquistare la licenza per creare le build e pubblicare la configurazione",
        "LabelLiveConfigNotUpdated": "La configurazione live view non è aggiornata — devi aggiornare la configurazione per poter vedere le modifiche nel Live Viewer",
        "LabelAppConfigNotUpdated": "La configurazione App non è aggiornata — devi pubblicarla per renderla disponibile alle build dell'app",
        "DialogPublish": "Pubblica Configurazione",
        "LabelConfirmPublishConfig": "Vuoi pubblicare la configurazione dell'App? Quando pubblichi la configurazione tutte le build dell'app useranno questa versione.",
        "DialogBuildApp": "Crea una Build",
        "LabelCantBuildiOS": "Build per iOS non disponibile — inserire la configurazione nel tab iOS",
        "LabelCantBuildAndroid": "Build per Android non disponibile — inserire la configurazione nel tab Android",
        "LabelCantBuildAnyPlatform": "La creazione delle Build non è disponibile - abilita e configura i tab per iOS e/o Android",
        "LabelCanBuildiOS": "Build per iOS disponibile — la creazione di una build genererà un bundle da scaricare",
        "LabelCanBuildAndroid": "Build per Android disponibile — la creazione di una build genererà un bundle da scaricare",
        "ButtonRefresh": "Aggiorna",
        "LabelMigrate": "Aggiorna",
        "LabelMigrateOldConfig": "Aggiorna la vecchia configurazione",
        "LabelPageNotFound": "404: La pagina che cerchi non esiste",
        "LabelShadyPath": "Hai manipolato l'indirizzo o sei venuto qui per errore. In ogni caso, usa la navigazione",
        "ButtonMigrate": "Aggiorna",
        "LabelMigrationNeeded": "Aggiornamento Richiesto",
        "LabelMigrationExplained": "Questa versione della plugin non è compatibile con la configurazione corrente della tua App. Devi aggiornarla, non temere, la procedura verrà eseguita in automatico!",
        "ButtonMigrateNow": "Clicca qui per iniziare l'aggiornamento",
        "MessageMigrationOk": "Configurazione aggiornata correttamente",
        "LabelHomeUrl": "URL Home",
        "HelperHomeUrl": "Specifica un URL della home page",
        "LabelSelectPage": "Seleziona pagina",
        "TitleUploadOverlayImages": "Carica le immagini di overlay",
        "TitleUploadScenarioImages": "Carica le immagini di scenario",
        "ButtonUploadOverlay": "Carica Overlay",
        "ButtonUploadScenario": "Carica Scenario",
        "LabelImageSource": "Origine delle Immagini",
        "LabelHelpPageLinkType": "Tipo Link Pagina Aiuto",
        "LabelHelpPageLink": "Link Help Page",
        "LabelMode": "Modalità",
        "LabelSelectHelpPage": "Seleziona la Pagina d'Aiuto",
        "LabelMigrationFailed": "Siamo terribilmente spiaciuti ma qualcosa è andato storto, puoi riprovare la procedura o saltare la migrazione (le vecchie impostazioni verranno perse).",
        "ButtonStartFromScratch": "SALTA LA MIGRAZIONE",
        "LabelNoAppConfigToBuild": "La configuration App non è pubblicata — devi pubblicarla per creare le build",
        "LabelBuildIsInProgress": "Preparazione dell'app bundle per cerazione build...",
        "LabelDownloadIsInProgress": "Preparazione dell'app bundle per il download...",

        "LabelGenericError": "Qualcosa è andato storto",
        "LabelGenericErrorMessage": "Un glitch nel sistema oppure un disturbo nella forza, prova ancora!",

        "LabelNoHttpError": "Protocollo HTTPS non rilevato",
        "LabelNoHttpErrorMessage": "Il tuo sito deve utilizzare HTTPS come protocollo",

        "LabelNoLocalError": "Il sito non è on line",
        "LabelNoLocalErrorMessage": "Il tuo sito deve essere on line, siam spiacenti!",

        "LabelCertWizardTitle": "Configurazione Certificati",
        "LabelStep": "Passo",
        "LabelOf": "di",
        "LabelCertWizardHelpTitle": "Non sai da dove cominciare?",
        "ButtonStartWizard": "INIZIA WIZARD",
        "LabeliOSCertWizardBundleId": "Per abilitare la procedura guidata devi prima aver configurato il valore <strong>Bundle Id</strong> nel tab <strong>Info</strong>.",

        "HelperAppleDevEmail": "Utilizza il tuo developer account Apple ID",
        "HelperAppleDevIssuerId": "Utilizza il tuo developer account Issuer ID che trovi nella console AppStore Connect",
        "HelperAppleDevKeyId": "Utilizza la key ID generata dalla console AppStore Connect",
        "HelperAppleDevTokenFile": "Carica il certiicato .p8 generato dalla console AppStore Connect",

        "LabeliOSCertWizardWizardHint": "Completa il wizard per ottenere un certificato <strong>.p12</strong> e un file <strong>.mobileprovision</strong>.<br /><br >Per creare le chiavi, devi avere un Admin account in App Store Connect.<br /><br />Clicca <a target='blank' href='https://developer.apple.com/documentation/appstoreconnectapi/creating_api_keys_for_app_store_connect_api'>qui</a> per una guida completa su come creare questi valori.",
        "LabeliOSCertWizardHelpBody": `
			<br />
			Per compilare la tua app <strong>iOS</strong> è necessario avere un certificato <strong>.p12</strong> e un file <strong>.mobileprovision</strong>. Puoi caricarli a mano oppure se ti serve aiuto,
			premi il bottone INIZIA WIZARD per iniziare una procedura guidata che ti aiuterà a configurare questa sezione in modo facile!
			<br />
			<br />
			I passi per completare quest'operazione sono facili ma è necesssario avere un account sviluppatore <strong>Apple</strong> per compilare e pubblicare la tua applicazione nello store.
			<br />
			<br />
			Nel caso dovessi registrare un nuovo account sviluppatore <strong>Apple</strong> puoi <a href="https://developer.apple.com/programs/" target="_blank">visitare il sito ufficiale</a>
			<br />
			<br />
		`,

        "HelperAndroidDevEmail": "Utilizza il tuo developer account Google ID",
        "HelperAndroidDevKSAlias": "Inserisci un identificativo per la tua key",

        "LabelAndroidCertWizardWizardHint": "Completa il wizard per ottenere un certificato <strong>.keystore</strong>.",
        "LabelAndroidCertWizardHelpBody": `
			<br />
			Per compilare la tua app <strong>Android</strong> è necessario avere un certificato <strong>.keystore</strong>. Puoi caricarlo a mano oppure se ti serve aiuto,
			premi il bottone INIZIA WIZARD per iniziare una procedura guidata che ti aiuterà a configurare questa sezione in modo facile!
			<br />
			<br />
			I passi per completare quest'operazione sono facili ma è necesssario avere un account sviluppatore <strong>Google</strong> per pubblicare la tua applicazione nello store.
			<br />
			<br />
            Nel caso dovessi registrare un nuovo account sviluppatore <strong>Google</strong> puoi <a href="https://play.google.com/console/about/" target="_blank">visitare il sito ufficiale</a>
			<br />
			<br />
		`,

        "LabelResetSettings": "Reset della configurazione",
        "LabelResetSettingsHelp": "Cancella la configurazione corrente della plugin, sovrascrivendo tutte le impostazioni con valore di default. Attenzione, l'operazione è distruttiva e non reversibile.",
        "DialogResetSettings": "Reset Configurazione",
        "LabelConfirmSettingsReset": "Sei sicuro di voler cancellare la configurazione corrente? Tutte le impostazioni verrano perse e non potranno essere ripristinate.",

        "LabelDrawerMenuLayout": "Usa menù di navigazione a scomparsa",
        "LabelTilesMenuLayout": "Usa menù di navigazione a tile",
        "LabelTabsMenuLayout": "Usa menù di navigazione a tab",

        "LabelUseLightStatusBar": "Usa barra di stato chiara",
        "HelperUseLightStatusBar": "Abilita questa impostazione se utilizzi un colore SCURO come colore primario nella tua app",

        "LabelUseUserLogin": "Usa il login utente",
        "HelperUseUserLogin": "Abilita questa impostazione se desideri che l'utente possa accedere alla tua app attraverso la procdura di login",

        "LabelLoginAlways": "Mostra sempre la schermata di login per accedere all'app",
        "LabelLoginAction": "Mostra la schermata di login solo quando una voce di menu è selezionata",
        "LabelLoginCode": "Mostra la schermata di login solo quando richiesta attraverso il bridge javascript",

        "LabelEntryTextColor": "Colore Testo Campi",
        "LabelEntryBackgroundColor": "Colore Sfondo Campi",
        "LabelErrorTextColor": "Colore Testo Errori",

        "LabelUseAllCategories": "Utilizza tutte le categorie",
        "HelperUseAllCategories": "Abilita questa impostazione se desideri che tutte le categorie siano disponibili nella tua lista",
        "LabelSelectCategory": "Seleziona Categoria",

        "LabelPostLayoutOneColumnPWT": "Il layout della lista di post sarà ad una colonna con immagine e titlo",
        "LabelPostLayoutOneColumnPWD": "Il layout della lista di post sarà ad una colonna con immagine e dettagli",
        "LabelPostLayoutTwoColumnsPWT": "Il layout della lista di post sarà ad due colonne con immagine e titolo",

        "LabelInfoGeneral": "Generale",
        "LabelInfoSharing": "Condivisione",
        "LabelInfoAuthentication": "Autenticazione",
        "LabelInfoMenuAndNavigation": "Navigazione",
        "LabelInfoStyleAndAppearance": "Aspetto",

        "LabelProtected": "Solo gli utenti registrati possono accedere a questo contenuto",
        "LabelAllowShareWebView": "Abilita l'utente alla condivisione del contenuto della webview",

        "LabelLoginPage": "Login Page .png (dim. suggerita 1152px X 2046px)",

        "LabelBackgroundImage": "Immagine di sfondo",
        "ButtonRemoveBkgImage": "Rimuovi immagine di sfondo",

        "LabelHideIcon": "Nascondi icona per questa voce di menù",
        "LabelHideTitle": "Nascondi titolo per questa voce di menù",

        "LabelLicenseId": "ID Licenza",
        "HelperLicenseId": "Utilizza questo valore quando acquisti la licenza per My FastAPP per questo sito",

        "LabelPreparingBuildDownload": "Preparazione download per",

        "MenuItemHomePage": "Home Page",
        "MenuItemBusinessCard": "Biglietto da Visita",
        "MenuItemMailTo": "Invia Email",
        "MenuItemEmptyLine": "Riga Vuota",
        "MenuItemOpenURL": "Apri URL",
        "MenuItemPhoneCall": "Chiamata",
        "MenuItemPhotoEditor": "Editor Foto",
        "MenuItemPhotoSend": "Invio Foto",
        "MenuItemQR": "QR",
        "MenuItemSeparator": "Separatore",
        "MenuItemSendSms": "Invio SMS",
        "MenuItemOnLineWebView": "Web View",
        "MenuItemPostList": "Lista Post",
        "MissingHomePageError": "Voce di menu di tipo '$type' assente",

        "YupValueRequired": "È richiesto un valore",
        "YupTitleRequired": "Un titolo è richiesto",
        "YupFileRequired": "Un file è richiesto",
        "YupLinkRequired": "Un link è richiesto",
        "YupPhoneNumberRequired": "Un numero di telefono è richiesto",
        "YupTemplateIdRequired": "Un template ID è richiesto",
        "YupEmailRequired": "Un indirizzo email è richiesto",
        "YupValidEmailRequired": "Deve essere un indirizzo valido",
        "YupUrlRequired": "Un URL è richiesto",
        "YupValidUrlRequired": "Deve essere un URL valido",
        "YupInvalidBundleId": "Bundle id non è corretto, sono consentiti solo: lettere, numeri, punti e underscore"
    }
};
export default it_IT;